import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { useAppContext } from "../../../../../../context/AppContext";
import UserCards from "./components/UserCards";
import SalesChart from "../../../standard/pages/dashboard/components/SalesChart";
import TopSellersUsers from "./components/TopSellersUsers";

export default function AdminDashboard() {
    const { setPageTitle, setPageUserID, appData } = useAppContext();

    const [licenseStats, setLicenseStats] = useState(null);
    const [userStats, setUserStats] = useState(null);

    const [errorMessage, setErrorMessage] = useState(null);


    useEffect(() => {
        setPageUserID(null);
        setPageTitle(appData?.name || "Admin Dashboard");
    }, [setPageTitle, setPageUserID, appData]);

    return (
        <UserPageLayout>
            <div className="content-body">
                <div className="container-fluid">
                {errorMessage && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <strong>{errorMessage?.status}</strong> {errorMessage?.message}
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                )}
                    <div className="row">

                        <div className="col-xl-6 col-lg-6">
                            <div className="row">
                                <UserCards userStats={userStats} setUserStats ={setUserStats} setErrorMessage={setErrorMessage}/>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-6">
                            <TopSellersUsers userStats={userStats} />
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-xxl-12 col-lg-12 col-sm-12">
                            <SalesChart licenseStats={licenseStats}  setLicenseStats={setLicenseStats} setErrorMessage={setErrorMessage} globalAppStats={true}/>
                        </div>
                    </div>

                </div>
            </div>
        </UserPageLayout>
    );
}